import { API } from "aws-amplify"

class ApiService {
  constructor() {
    this.baseURL = (
      process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_APP_V2_BACKEND_URL ||
      process.env.REACT_APP_STUFF_MDERATION_API ||
      "http://localhost:3000"
    ).replace(/\/+$/, "")
  }

  // Get auth token
  getAuthToken() {
    const prefix = localStorage.getItem("keyprefix")
    if (prefix) {
      const idUser = localStorage.getItem(`${prefix}.LastAuthUser`)
      return localStorage.getItem(`${prefix}.${idUser}.idToken`)
    }
    return ""
  }

  // Custom fetch with CORS handling
  async customFetch(endpoint, options = {}) {
    const token = this.getAuthToken()
    
    const config = {
      method: options.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers
      },
      ...options
    }

    // Add body for POST/PUT requests
    if (options.body && ['POST', 'PUT', 'PATCH'].includes(config.method)) {
      config.body = JSON.stringify(options.body)
    }

    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, config)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      return await response.json()
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  }

  // Stuffs API methods
  async getStuffs() {
    return this.customFetch('/stuffs')
  }

  async createStuff(payload) {
    return this.customFetch('/v1/staff', {
      method: 'POST',
      body: payload
    })
  }

  async updateStuff(id, payload) {
    return this.customFetch(`/stuffs/${id}`, {
      method: 'PUT',
      body: payload
    })
  }

  async deleteStuff(id) {
    return this.customFetch(`/stuffs/${id}`, {
      method: 'PUT',
      body: { status: "DELETED" }
    })
  }

  async enableStuff(id) {
    return this.customFetch(`/stuffs/${id}`, {
      method: 'PUT',
      body: { status: "ACTIVE" }
    })
  }

  async disableStuff(id) {
    return this.customFetch(`/stuffs/${id}`, {
      method: 'PUT',
      body: { status: "DISABLED" }
    })
  }

  async resetPassword(id, password) {
    return this.customFetch(`/stuffs/${id}/account`, {
      method: 'PUT',
      body: { password }
    })
  }

  // Fallback to Amplify API if custom fetch fails
  async fallbackAmplifyAPI(apiName, endpoint, options = {}) {
    try {
      return await API.post(apiName, endpoint, options)
    } catch (error) {
      console.error('Amplify API Error:', error)
      throw error
    }
  }
}

export default new ApiService() 